import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import SampleCollectionVideo from "../../../components/SampleCollectionVideo";

export const SampleCollectionVideoCard = ({ t }) => (
  <Box sx={{ maxWidth: 800, mx: "auto", mb: 3 }}>
    <Card elevation={0} sx={{ border: "1px solid #dfdfdf", borderRadius: 2 }}>
      <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#1a1a2e", mb: 3 }}>
          {t.sampleCollectionVideoTitle}
        </Typography>
        <SampleCollectionVideo
          title={t.sampleCollectionVideoTitle}
          labels={t.sampleCollectionVideoPlayer}
        />
      </CardContent>
    </Card>
  </Box>
);
